import { ComplianceStatus, ProviderStatus } from '@montatec/contracts'
import styles from './Status.module.css'
import Chip from '../chip/Chip'

type Props = 
| {
    type: "provider" 
    status: ProviderStatus
  }
| {
    type: "compliance" 
    status: ComplianceStatus
  }

export default function Status({type, status}: Props) {
  
  let nameStatus = ""
  let colorStyle : "red" | "green" | "yellow" | "orange" | "gray" | "white" = "white"
  
  if(type === "provider") {

    if(status === ProviderStatus.UP_TO_DATE) {
      nameStatus = "Al día"    
      colorStyle = 'green'
    }

    if(status === ProviderStatus.AT_RISK) {
      nameStatus = "En riesgo"    
      colorStyle = 'yellow'
    }

    if(status === ProviderStatus.NON_COMPLIANT) {
      nameStatus = "Incumplido"    
      colorStyle = "red"
    }

    if(status === ProviderStatus.OBSOLETE) {
      nameStatus = "Obsoleto"    
      colorStyle = "gray"
    }


  } else if(type === "compliance") {
    
    if(status === ComplianceStatus.CURRENT) {
      nameStatus = "Vigente"    
      colorStyle = "green"
    }

    if(status === ComplianceStatus.SUBMITTED) {
      nameStatus = "Entregado"    
      colorStyle = "green"
    }

    if(status === ComplianceStatus.AT_RISK) {
      nameStatus = "En riesgo"    
      colorStyle = "yellow"
    }

    if(status === ComplianceStatus.EXPIRED) {
      nameStatus = "Vencido"    
      colorStyle = "red"
    }

    if(status === ComplianceStatus.PENDING) {
      nameStatus = "Pendiente"    
      colorStyle = "orange"
    }


  }
  
  return (
    <Chip className={`${styles.status} ${styles[nameStatus]} ${styles[colorStyle]}`}>
      {nameStatus}
    </Chip>
  )
}
